<div #container class="prose mat-font-body-sm" (click)="handleClick($event)"></div>
